"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hash_js_1 = require("hash.js");

exports.default = function (message, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.hexPrefix,
      hexPrefix = _c === void 0 ? true : _c,
      _d = _b.inputEnc,
      inputEnc = _d === void 0 ? null : _d,
      _e = _b.outputEnc,
      outputEnc = _e === void 0 ? 'hex' : _e;

  return (hexPrefix ? '0x' : '') + hash_js_1.sha256().update(message, inputEnc).digest(outputEnc);
};